import { ArcadeIconNames } from './ArcadeIcon'
import { ArcadePaymentIconNames } from './ArcadePaymentIcon'
import type { OptionalRecord } from './iconMappings.generated'

export const ARCADE_ICON_VIEWBOX_MAPPING: OptionalRecord<ArcadeIconNames | ArcadePaymentIconNames, string> = {
  ShoppingCart: '0.0 3.0 23.0 19.0',
  Borrow: '2.0 1.5 20.0 18.5',
  MenuAfterpay: '2.5 3.5 19.0 17.0',
  NoCreditCheck: '0.5 3.0 23.0 16.7',
  Fast: '1.8 3.0 20.2 18.2',
  Limits: '3.0 3.5 18.0 17.0',
  Zero: '2.3 2.3 19.4 19.4',
  Add: '3.0 3.0 18.0 18.0',
  TickerDown: '5.0 4.0 14.0 17.0',
  TickerUp: '5.0 4.0 14.0 17.0',
  BankAccount: '2.5 3.2 19.0 16.8',
  Date: '3.5 3.5 17.0 17.0',
  CameraFill: '2.0 3.0 20.0 16.0',
  CategoryAuto: '0.0 3.0 24.0 18.0',
  CardBasic: '1.5 4.0 21.0 16.0',
  CardInactive: '2.0 4.0 20.5 16.5',
  Expand: '12.0 10.0 12.0 7.0',
  Push: '16.0 6.0 7.0 12.0',
  Collapse: '12.0 9.0 12.0 7.0',
  CommChat: '1.5 3.0 21.0 18.0',
  DepositCheck: '1.0 3.0 22.0 18.0',
  DepositBarcode: '1.0 3.0 22.0 18.0',
  Close: '2.5 2.5 19.0 19.0',
  Clear: '4.0 3.0 16.0 18.0',
  SwapCurrency: '4.0 4.0 16.0 16.0',
  CurrencyUsd: '5.5 2.0 12.9 20.0',
  Download: '4.0 3.0 16.0 18.0',
  Edit: '3.0 2.8 17.2 17.2',
  CommEmail: '2.0 4.0 20.0 16.0',
  LogOut: '4.0 4.0 17.0 16.0',
  Control: '2.0 3.0 20.0 18.0',
  Giftcard: '2.0 3.0 20.0 18.0',
  International: '2.0 2.0 20.0 20.0',
  Like: '2.0 4.0 20.0 17.0',
  Time: '2.0 2.0 20.0 20.0',
  CategoryRent: '1.0 4.0 22.0 17.0',
  InformationOutline: '2.0 2.0 20.0 20.0',
  BitcoinLightning: '4.0 2.0 16.0 20.0',
  Hyperlink: '4.0 4.0 16.0 16.0',
  Location: '4.0 2.5 16.0 18.8',
  LockLocked: '3.5 2.0 17.0 19.5',
  CommSmsFill: '3.0 4.0 18.0 16.4',
  DeviceMobile: '5.0 3.0 14.0 18.0',
  PayLater: '3.5 3.5 17.0 17.0',
  TransferWire: '3.0 3.5 19.0 18.5',
  More: '3.0 10.0 18.0 4.0',
  Notifications: '4.3 3.0 15.5 18.5',
  SensitiveHidden: '2.1 3.5 19.7 17.0',
  SensitiveVisible: '2.1 6.0 19.7 12.0',
  CommPhoneFill: '4.0 4.0 16.0 16.0',
  Data: '3.0 2.5 19.5 19.5',
  Savings: '2.0 2.0 20.0 18.0',
  Avatar: '3.0 3.0 18.0 18.0',
  Refresh: '3.0 2.0 17.0 20.5',
  Refunded: '4.0 5.0 16.0 14.0',
  Search: '3.0 3.0 18.0 18.0',
  Send: '4.0 4.5 15.5 15.5',
  Share: '4.0 3.0 16.0 18.0',
  CategoryShopping: '1.0 3.0 22.0 18.0',
  CardSupport: '2.0 4.0 20.8 18.5',
  AlertReportedFill: '2.0 4.0 20.0 16.0',
  AlertFill: '3.0 3.0 18.0 18.0',
  DiscountTagFill: '2.0 2.0 20.0 20.0',
  DiscountPercentage: '4.0 4.0 16.0 16.0',
  Business: '2.5 4.0 19.0 16.0',
  FavoriteFill: '3.0 3.0 18.0 18.0',
  Favorite: '3.0 3.0 18.0 18.0',
  Copy: '3.0 2.0 18.0 20.0',
  LocationFill: '4.0 3.0 16.0 19.0',
  LocationDuo: '3.0 3.0 19.0 19.0',
  PayInFour: '3.0 3.0 18.0 18.0',
  LinkOut: '3.0 3.0 18.0 18.0',
  CategoryMoving: '1.5 3.0 21.0 19.0',
  Delivery: '0.0 4.0 24.0 17.0',
  Idea: '5.0 2.0 14.0 20.0',
  AccountVerified: '1.0 1.0 22.0 22.0',
  DiscountTag: '2.0 2.0 20.0 20.0',
  Attach: '4.0 2.0 17.0 20.0',
  BackCentered: '9.0 6.0 7.0 12.0',
  TickerLeft: '3.0 5.0 17.0 14.0',
  TickerRight: '4.0 5.0 17.0 14.0',
  CheckFill: '3.0 3.0 18.0 18.0',
  FailedFill: '3.0 3.0 18.0 18.0',
  RecurringAutomatic: '3.0 1.0 18.5 22.0',
  Printer: '2.0 4.5 20.0 17.5',
  Document: '4.0 2.5 16.0 19.0',
  LogoAfterpay: '3.0 4.0 18.0 16.0',
  Check: '2.1 3.1 13.0 10.5',
  CardAdd: '1.5 4.0 21.5 17.0',
  CategoryHealthMedical: '3.0 3.0 19.0 18.5',
} as const
